/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import useOpenedState from '../../../hooks/useOpenedState';
import * as AppPropTypes from '../../../lib/PropTypes';

import { useTheme } from '../../../contexts/ThemeContext';
import { useThemeClassName } from '../../../contexts/ThemeContext';
import HeaderDefault from '../../partials/HeaderDefault';
import OtherLocales from '../../partials/OtherLocales';
import FooterNFL from './Footer';

import styles from '../../../../styles/themes/nfl/header-nfl.module.scss';

const propTypes = {
    className: PropTypes.string,
    pageUrls: AppPropTypes.pageUrls,
    footerMenuItems: AppPropTypes.menuItems,
};

const defaultProps = {
    className: null,
    pageUrls: null,
    footerMenuItems: null,
};

function HeaderNFL({ className, pageUrls, footerMenuItems, ...props }) {
    const openedState = useOpenedState();
    const { closeMenu } = openedState;
    const { header } = useTheme();
    const themeClassName = useThemeClassName(styles);
    const { theme = null } = header || {};

    return (
        <HeaderDefault
            className={classNames([styles.container, themeClassName, styles[theme], className])}
            innerClassName={styles.inner}
            fixedContentClassName={styles.fixedContent}
            logoClassName={styles.logo}
            togglerClassName={styles.toggler}
            toggleContentClassName={styles.toggleContent}
            togglerOpenedClassName={styles.togglerOpened}
            itemsClassName={styles.items}
            itemClassName={styles.item}
            openedState={openedState}
            withoutOtherLocales
            menuChildren={
                <>
                    <div className={styles.content}>
                        <OtherLocales
                            className={styles.otherLocales}
                            linkClassName={styles.otherLocale}
                            pageUrls={pageUrls}
                        />
                    </div>
                    <FooterNFL
                        className={styles.footer}
                        menuClassName={styles.footerMenu}
                        menuItemsClassName={styles.footerMenuItems}
                        itemActiveClassName={styles.footerMenuItemActive}
                        menuItems={footerMenuItems}
                        onMenuItemClick={closeMenu}
                        withoutDisclaimer
                    />
                </>
            }
            {...props}
        />
    );
}

HeaderNFL.propTypes = propTypes;
HeaderNFL.defaultProps = defaultProps;

export default HeaderNFL;
